import { courseApi } from "./index";

export interface StudentRegistrationAvailableListParams {
  courseId: string;
  studentIds?: Array<string>;
  name?: string;
  email?: string;
  belongToContractorId?: string;
  notBelongToContractorId?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "name" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (
  params: StudentRegistrationAvailableListParams,
  options?: any
) => {
  return courseApi.CourseRegistration.listCourseRegistrationsAvailableStudents(
    params.courseId,
    params.studentIds,
    params.name,
    params.email,
    params.belongToContractorId,
    params.notBelongToContractorId,
    params.createdAtMin,
    params.createdAtMax,
    params.offset,
    params.limit,
    params.sort
  );
};
